import { getOffsetParent as w } from "../utils/getOffsetParent.mjs";
var s = function(a, r, t) {
  var i = Math.min(r, t), c = Math.max(r, t);
  return Math.min(Math.max(a, i), c);
}, x = function() {
  return {
    x: 0,
    y: 0,
    width: window.innerWidth,
    height: window.innerHeight
  };
}, b = {
  name: "cursorAnchoring",
  phase: "beforeRead",
  enabled: !0,
  fn: function(a) {
    var r = a.state, t = a.options, i = r.options.placement, c = !i || i.startsWith("top") || i.startsWith("bottom"), M = t.cursorAnchoring, n = t.mouseEnterCursorPositionRef, e = r.rects, p = r.elements;
    if (M)
      if (c) {
        var o, l = w(p.popper), R = l === window ? x() : l.getBoundingClientRect(), g = n == null || (o = n.current) === null || o === void 0 ? void 0 : o.x;
        if (g === void 0) return;
        var v = Math.min(e.reference.width, e.popper.width), W = s(g - R.x - v / 2, e.reference.x, e.reference.x + e.reference.width - v);
        e.reference.x = W, e.reference.width = v;
      } else {
        var h, m = w(p.popper), y = m === window ? x() : m.getBoundingClientRect(), u = n == null || (h = n.current) === null || h === void 0 ? void 0 : h.y;
        if (u === void 0) return;
        var d = Math.min(e.reference.height, e.popper.height), A = s(u - y.y - d / 2, e.reference.y, e.reference.y + e.reference.height - d);
        e.reference.y = A, e.reference.height = d;
      }
  }
};
export {
  b as cursorAnchoringModifier
};
